import { IdleReminder } from '@trip-ux/components/idle-reminder';
import { ReduxStore, useActions, keepingAlive } from '@trip-ux/redux-store';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { labelsSelector } from './utils';

export const SessionContainer: FC<{
  countDownSeconds: number;
  homePage: string;
}> = ({ countDownSeconds, homePage }) => {
  const { labels } = useSelector((store: ReduxStore) => ({
    labels: labelsSelector(store)
  }));
  const actions = useActions({ keepingAlive });

  const handleCancel = () => {
    window.location.href = homePage;
  };

  const handleRefresh = () => {
    actions.keepingAlive();
  };

  return (
    <IdleReminder
      countDownSeconds={countDownSeconds}
      refresh={handleRefresh}
      cancel={handleCancel}
      labels={labels.session_container}
    />
  );
};

SessionContainer.displayName = 'SessionContainer';
export default SessionContainer;
